import Element from 'ui/Element';
import mixin from 'privates/utils/mixin';
import HiddenCollapsedMixin from './mixins/HiddenCollapsedMixin';
import _ from 'lodash';

class Native extends Element {
    constructor(RMI, compId, contextId, wixSelector, controllerId, role, type) {
        super(RMI, compId, contextId, wixSelector, controllerId, role, type);
        const publicAPI = RMI.getPublicAPI(compId);
        if (_.isFunction(publicAPI)) {
            const controllerData = RMI.getData(compId);
            const exportsObject = publicAPI(RMI.getCurrentScope(), wixSelector.scoped$W(controllerData.id));
            mixin(this, exportsObject);
        } else if (publicAPI) {
            _.assign(this, publicAPI);
        }
    }
}

mixin(Native.prototype, HiddenCollapsedMixin.prototype);

export default Native;



// WEBPACK FOOTER //
// ./js/modules/ui/Native.es6